import * as React from 'react';

export class ServiceNowSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          id="50250920-ca4c-4a3f-8907-6377890d65c0"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
      >
        <path
          d="M42.07157,27.52486c.57806-2.60941,1.14534-5.143,1.699-7.67958A1.68381,1.68381,0,0,1,46.628,18.75646a.73658.73658,0,0,
          1,.33284.88642q-1.52746,5.51651-3.04274,11.03639a1.15776,1.15776,0,0,1-1.0701.92517,7.84135,7.84135,0,0,1-1.03433.04243,1.33379,
          1.33379,0,0,1-1.50344-1.137c-.60542-1.85665-1.195-3.71844-1.79192-5.57786a1.75206,1.75206,0,0,0-.3637-.78288c-.26543.784-.51231,
          1.50037-.75056,2.21963-.45549,1.37506-.89519,2.75546-1.36237,4.12652-.33748.99041-.73507,
          1.1995-2.05588,1.15469-1.01071-.03429-1.35552-.2946-1.62381-1.25193-.99223-3.54049-1.97406-7.08393-2.97832-10.621a.821.821,0,0,
          1,.425-1.08389c1.3335-.789,2.45928-.34329,2.8099,1.17531.54836,2.375,1.06912,4.75646,1.60336,
          7.13478.04.17794.09421.35268.196.72937.38677-1.20392.71908-2.2289,
          1.04514-3.25587.3269-1.02961.64327-2.06257.9723-3.09149.26652-.83342.76433-1.13906,1.8247-1.13987,1.05748-.00081,1.5272.28685,1.79887,
          1.15209.55811,1.77748,1.098,3.56067,1.65308,5.33911A1.59475,1.59475,0,0,0,42.07157,27.52486Z"
          fill="#d02229"
        />
        <path
          d="M5.99193,19.94408A5.30411,5.30411,0,0,1,11.37722,18.483a4.73114,4.73114,0,0,1,3.45533,4.84459c.036,2.30465.01742,4.61034.00461,
          6.91548-.00568,1.02155-.441,1.40229-1.52614,
          1.40459-1.05289.00223-1.5021-.39821-1.5109-1.42864-.0179-2.09759-.00381-4.19543-.00987-6.29316a3.11573,3.11573,0,0,0-.66138-2.06071,
          3.01741,3.01741,0,0,0-3.97113-.20185,2.38631,2.38631,0,0,0-1.13757,2.1395c.06259,2.0728.02609,4.14884.017,6.22348A1.524,1.524,0,0,1,
          3.76709,31.577a1.04852,1.04852,0,0,1-.68684-.80664,4.07711,4.07711,0,0,
          1-.05965-.75571c-.00327-3.50392.02117-7.00811-.02043-10.51153-.00847-.713.29982-.93877.89557-1.02623C4.84656,
          18.3373,5.45639,18.748,5.99193,19.94408Z"
          fill="#d02229"
        />
        <path
          d="M22.23455,31.65152a6.01832,6.01832,0,0,1-5.3553-3.16159,6.9715,6.9715,0,0,1,.029-7.11453c.7089-1.25824,1.79943-1.479,
          2.72918-.65383a.85978.85978,0,0,1,.13652,1.35492,4.50722,4.50722,0,0,0-.49329,4.88151A3.68055,3.68055,0,0,0,23.478,28.98807a3.8563,
          3.8563,0,0,0,2.98473-3.61645,4.97345,4.97345,0,0,0-.84092-3.14308c-.29848-.45217-.64677-.85071-.09675-1.38191a1.63333,1.63333,0,0,1,
          1.93462-.43908,2.83111,2.83111,0,0,1,1.04167,1.17,6.87875,6.87875,0,0,1-2.49114,9.26486A7.51832,7.51832,0,0,1,22.23455,31.65152Z"
          fill="#d02229"
        />
        <path
          d="M23.987,22.46885c.00028.92154.01931,1.84358-.005,2.76448-.02476.93663-.48681,1.38754-1.35114,
          1.38128-.845-.00612-1.29346-.48817-1.29743-1.43q-.01148-2.73009-.00016-5.46026c.00445-.99712.40048-1.4506,
          1.24433-1.4675.97048-.01943,1.37839.38327,1.40446,1.44748C24.00458,20.62534,23.9867,21.54731,23.987,22.46885Z"
          fill="#d02229"
        />
      </svg>
    )
  }
}